globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Emailing = appCustomerSpace.Modals.Emailing || {};

appCustomerSpace.Modals.Emailing.NewNewsletter = (function(superClass) {

  utils.extend(NewNewsletter, superClass);

  function NewNewsletter() {
    return NewNewsletter.__super__.constructor.apply(this, arguments);
  }

  var GOAL_TO_INTENT = {
    service_highlight: "showcase",
    new_service_launch: "sell",
    customer_need_approach: "sell",
    blog_article_zoom: "inform",
    tips_advice_tutorial: "advise",
    news_logbook: "inform",
    promotion_special_offer: "sell",
    new_year: "celebrate"
  };

  var AI_LOADER_STEPS = [
    "L'IA analyse votre objectif marketing…",
    "L'IA structure le plan de la newsletter…",
    "L'IA rédige les sections…",
    "L'IA peaufine le style éditorial…",
    "L'IA met en forme la newsletter…",
    "Préparation de votre interface…"
  ];

  var DEFAULT_LOADER_STEPS = [
    "Préparation de votre newsletter…"
  ];

  $.extend(NewNewsletter.prototype, {
    init: function() {
      this._bindMarketingGoal();
      this._bindAiToggle();
      this._bindAutoHeight();
      appCustomerSpace.SelectFollower.bind(this.$html, "goal-to-intent", GOAL_TO_INTENT, {
        onlyIfTargetEmpty: false
      });

      return NewNewsletter.__super__.init.apply(this, arguments);
    },

    callbackSuccess: function(data) {
      if (data && data.response === 1) {
        this._showLoader(data);
      } else if (data && data.redirect_url) {
        window.location.assign(data.redirect_url);
      } else {
        new PNotify({ icon: 'icon-cross2', title: "Une erreur s'est produite", type: 'error', delay: 3000 });
        this.close();
      }
    },

    callbackError: function() {
      new PNotify({ icon: 'icon-cross2', title: "Une erreur s'est produite", type: 'error', delay: 3000 });
      this.close();
    },

    _showLoader: function(data) {
      var $modal = this.$html;
      var $body = $modal.find('.modal-body');
      var $footer = $modal.find('.modal-footer');
      var $header = $modal.find('.modal-header');

      appCustomerSpace.Loader().stop({ $container: $modal.find('.modal-content') });

      $footer.hide();
      $header.find('button[data-dismiss="modal"]').hide();
      $body.html('<div class="steps-loader-placeholder" style="min-height: 240px; position: relative;"></div>');

      var $container = $body.find('.steps-loader-placeholder');

      var aiEnabled = $modal.find('form').first().data('ai-loader') === true;
      var steps = aiEnabled ? AI_LOADER_STEPS : DEFAULT_LOADER_STEPS;

      var handle = appCustomerSpace.StepsLoader.start({
        $container: $container,
        steps: steps,
        minDelayMs: 2500,
        maxDelayMs: 4500,
        loaderOptions: { style: { backdrop: { background: '#fff' } } }
      });

      this._subscribeContentChannel(data, handle);
    },

    _subscribeContentChannel: function(data, handle) {
      App.cable.subscriptions.create({
        channel: "CustomerSpace::Emailing::Email::ContentChannel",
        project_uniq_key: data.project_uniq_key
      }, {
        received: function(payload) {
          if (payload.action === 'email_content_ready' &&
              payload.newsletter_uniq_key === data.newsletter_uniq_key) {
            handle.stop();
            window.location.assign(payload.redirect_url);
          }
        }
      });
    },

    _bindAutoHeight: function() {
      this.$html.on("input", ".js-auto-height", function() {
        this.style.height = "auto";
        this.style.height = this.scrollHeight + "px";
      });
    },

    _bindMarketingGoal: function() {
      var $modal = this.$html;
      var $select = $modal.find('[data-js-target="marketing-goal-select"]');
      var refresh = function() {
        var value = $select.val();
        $modal.find('.js-conditional-field').each(function() {
          var $field = $(this);
          var showIf = $field.data('show-if-marketing-goal');
          var hideIf = $field.data('hide-if-marketing-goal');
          var visible;
          if (showIf !== undefined) {
            visible = $.inArray(value, String(showIf).split(',')) !== -1;
          } else if (hideIf !== undefined) {
            visible = $.inArray(value, String(hideIf).split(',')) === -1;
          } else {
            visible = true;
          }
          $field.toggle(visible);
        });
      };
      $select.on('change', refresh);
      refresh();
    },

    _bindAiToggle: function() {
      var $modal = this.$html;
      var $toggle = $modal.find('[data-js-target="ai-toggle"]');
      var $aiFields = $modal.find('.js-ai-fields');
      var refresh = function() {
        $aiFields.toggle($toggle.is(':checked'));
      };
      $toggle.on('change', refresh);
      refresh();
    }
  });

  return NewNewsletter;

})(appCustomerSpace.Modal);
